/**
 * useEntitlements — Read workspace entitlements from auth/org context.
 *
 * Entitlements are billing-driven; users never toggle modules.
 * Reads the typed `entitlements` field on the org payload and falls back
 * to SAFE defaults (both DISABLED) so no module is accessible unless
 * explicitly granted.
 */

import { useAuth } from '@/lib/auth';

export interface Entitlements {
  scout: boolean;
  scheduler: boolean;
}

/**
 * Default entitlements — both DISABLED (safe default).
 * Modules are only accessible when explicitly enabled in org payload.
 */
const DEFAULT_ENTITLEMENTS: Entitlements = {
  scout: false,
  scheduler: false,
};

export function useEntitlements(): Entitlements {
  const { org } = useAuth();

  return {
    scout: org?.entitlements?.scout ?? DEFAULT_ENTITLEMENTS.scout,
    scheduler: org?.entitlements?.scheduler ?? DEFAULT_ENTITLEMENTS.scheduler,
  };
}
